import React from 'react';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';
import styles from './entity_decision_list_modal.module.scss';

type Props = {
  title: string;
  subtitle: string;
  onClose: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export function EntityDecisionListModalHeader({
  title,
  subtitle,
  onClose,
}: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div className={styles.close} onClick={onClose}>
        <MaterialIcon name="close" />
      </div>
    </div>
  );
}
